import React from 'react';
import { Button } from 'antd';

const CustomModal= ({
                           visible,
                           onClose,
                           title,
                           description,
                           buttonText,
                           buttonAction,
                         }) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        backdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: 360,
          background: 'white',
          borderRadius: 10,
          padding: '24px 28px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }} dangerouslySetInnerHTML={{ __html: title }}></h3>
        <p style={{ fontSize: 14, color: '#555', marginBottom: 24 }}  dangerouslySetInnerHTML={{ __html: description }}></p>
        <Button
          type="primary"
          size="large"
          style={{ width: '100%', borderRadius: 6 }}
          onClick={buttonAction}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default CustomModal;
